// این ماژول تضمین می‌کند که بعد از هر دیپلوی جدید (از طریق CI/CD یا هر روش دیگر)، همه‌ی
// کاربران (چه روی موبایل چه دسکتاپ) بدون نیاز به رفرش دستی یا پاک کردن کش، خودکار نسخه‌ی
// جدید را بگیرند — صرف‌نظر از اینکه سرور میزبان (IIS/Nginx/GitHub Pages/هر چیز دیگر) چه
// تنظیمات کشی دارد.
//
// روش کار: فایل asset-manifest.json که create-react-app در هر build خودکار می‌سازد، همیشه
// محتوایش عوض می‌شود (چون نام تمام فایل‌های static بر اساس هش محتوایشان است). با
// fetch(..., { cache: "no-store" }) + یک query-param یکتا (تایم‌استمپ)، این درخواست همیشه
// مستقیم از شبکه خوانده می‌شود و از هر کش (مرورگر، CDN، خودِ وب‌سرور) عبور می‌کند. اگر محتوای
// این فایل با نسخه‌ای که هنگام لود اول صفحه گرفته بودیم فرق کند، یعنی نسخه‌ی جدیدی دیپلوی شده
// و صفحه را خودکار رفرش می‌کنیم.
let lastManifest: string | null = null;

const manifestUrl = () => `${process.env.PUBLIC_URL}/asset-manifest.json?_=${Date.now()}`;

const checkForUpdate = async () => {
  try {
    const res = await fetch(manifestUrl(), { cache: "no-store" });
    if (!res.ok) return;
    const text = await res.text();

    if (lastManifest === null) {
      lastManifest = text;
      return;
    }

    if (text !== lastManifest) {
      window.location.reload();
    }
  } catch {
    // خطای شبکه/آفلاین بودن را نادیده می‌گیریم؛ چک بعدی دوباره تلاش می‌کند.
  }
};

export const startUpdateWatcher = () => {
  checkForUpdate();

  const intervalId = window.setInterval(checkForUpdate, 5 * 60 * 1000);

  const onVisibilityChange = () => {
    if (document.visibilityState === "visible") checkForUpdate();
  };
  document.addEventListener("visibilitychange", onVisibilityChange);
  window.addEventListener("focus", checkForUpdate);

  return () => {
    window.clearInterval(intervalId);
    document.removeEventListener("visibilitychange", onVisibilityChange);
    window.removeEventListener("focus", checkForUpdate);
  };
};
